import DatePickerDateComponent from './date-picker-date-component.js'
import { css, CSSResultGroup } from 'lit'
import { customElement } from 'lit/decorators.js'
import { DatePickerMode } from './date-picker-component.js'

/**
 * slots:
 *  -
 */
@customElement('il-date-picker-date-reschedule')
export default class DatePickerDateRescheduleComponent extends DatePickerDateComponent {
  static override styles: CSSResultGroup = [
    DatePickerDateComponent.styles,
    css`
      .il-date-picker-date.il-date-picker-date--reschedule {

      }
    `
  ]

  protected override mode: string = DatePickerMode.RESCHEDULE
  protected override extraCSSClasses: string = 'il-date-picker-date--reschedule'

  override get price (): number {
    return parseFloat(this.availabilityDate?.reschedulePrice ?? 0) ?? 0
  }

  override get showTooltip (): boolean {
    return !this.isPast && this.shouldShowTooltip && !this.isLoading && this.price > 0
  }

  override get priceToDisplay (): string {
    if (this.isPast || !this.availabilityDate || this.isSoldOut || this.isLoading) {
      return ''
    }

    const price = this.price
    const formattedPrice = `${this.formattedCurrencySymbol}${price.toFixed(0)}`

    // price to display label when price is 0
    if (price === 0) {
      return (this.samePriceLabel && this.samePriceLabel.replace('[price]', formattedPrice))
        ?? ''
    }

    if (this.priceHasOverflow) {
      return `+${this.formattedCurrencySymbol}`
    }

    // allows external overrides of what we display on the price section
    if (this.priceTextOverride) {
      return this.priceTextOverride
      .replace('[currency]', this.formattedCurrencySymbol)
      .replace('[price]', formattedPrice)
    }

    if (price > 0) {
      return `${formattedPrice}+`
    }

    return ''
  }

  override get tooltipText (): string {
    if (this.isSoldOut) {
      return this.soldOutTooltipLabel ?? 'Sold Out'
    }

    const price = this.price

    if (price === 0) {
      return ''
    }

    const formattedPrice = `${this.formattedCurrencySymbol}${price.toFixed(0)}`

    if (this.tooltipTextOverride) {
      return this.tooltipTextOverride.replace('[price]', formattedPrice)
    }

    return `Costs ${formattedPrice} more`
  }
}
